import { doc, getDoc, setDoc, updateDoc, deleteField } from "firebase/firestore";
import { db } from "../firebase";

// Mismo patrón doc-por-usuario que hiddenOffers/hiddenCompanies (ver
// homeUtils.js): blockedUsers/{userId} = { [targetUid]: true, ... }.
export const blockUser = async (currentUid, targetUid) => {
  if (!currentUid || !targetUid || currentUid === targetUid) return false;
  try {
    await setDoc(doc(db, "blockedUsers", currentUid), { [targetUid]: true }, { merge: true });
    return true;
  } catch (error) {
    console.error("Error al bloquear usuario:", error);
    return false;
  }
};

export const unblockUser = async (currentUid, targetUid) => {
  if (!currentUid || !targetUid) return false;
  try {
    await updateDoc(doc(db, "blockedUsers", currentUid), { [targetUid]: deleteField() });
    return true;
  } catch (error) {
    console.error("Error al desbloquear usuario:", error);
    return false;
  }
};

export const fetchBlockedIds = async (userId) => {
  if (!userId) return [];
  try {
    const snap = await getDoc(doc(db, "blockedUsers", userId));
    return snap.exists() ? Object.keys(snap.data()) : [];
  } catch (error) {
    console.error("Error al obtener usuarios bloqueados:", error);
    return [];
  }
};

// El bloqueo corta el chat en cualquier dirección: si yo bloqueé a alguien,
// o esa persona me bloqueó a mí, ninguno de los dos puede escribirle al otro.
export const isBlockedBetween = async (uidA, uidB) => {
  if (!uidA || !uidB) return false;
  const [blockedByA, blockedByB] = await Promise.all([
    fetchBlockedIds(uidA),
    fetchBlockedIds(uidB),
  ]);
  return blockedByA.includes(uidB) || blockedByB.includes(uidA);
};
